import { Link } from 'react-router-dom';
import { SEOHead } from '@/components/layout/SEOHead';
import { FadeIn } from '@/components/motion/FadeIn';

export function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="Page not found · Brian Ellison Design"
        description="The page you're looking for couldn't be found."
      />
      <section className="not-found">
        <div className="container not-found__inner">
          <FadeIn>
            <p className="eyebrow">404 — Page not found</p>
            <h1 className="not-found__title">
              <em>A door</em> that doesn't open.
            </h1>
            <p className="subtitle">
              The page you're looking for has either been moved or never built. Most
              of what's here lives behind one of the doors below.
            </p>
            <div className="not-found__cta">
              <Link to="/" className="cta-primary">Home</Link>
              <Link to="/projects" className="cta-ghost">View projects</Link>
              <Link to="/journal" className="cta-ghost">Read the journal</Link>
            </div>
          </FadeIn>
        </div>
        <p className="ornament container" aria-hidden="true">§</p>
      </section>
    </>
  );
}
